// Types
import type { TSpinnerProps, TSpinnerSize } from './Spinner.type';

export const SPINNER_SIZES: TSpinnerSize[] = ['sm', 'md', 'lg']
export const SPINNER_SIZE: { [key in TSpinnerSize]: key } = {
	sm: 'sm',
	md: 'md',
	lg: 'lg',
}

export const SPINNER_DEFAULT_PROPS: TSpinnerProps = {
	size: SPINNER_SIZE.md
}
